import { render, staticRenderFns } from "./r-ad-placement-dropdown-multiple.vue?vue&type=template&id=e65f6608"
import script from "./r-ad-placement-dropdown-multiple.vue?vue&type=script&lang=js"
export * from "./r-ad-placement-dropdown-multiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e65f6608')) {
      api.createRecord('e65f6608', component.options)
    } else {
      api.reload('e65f6608', component.options)
    }
    module.hot.accept("./r-ad-placement-dropdown-multiple.vue?vue&type=template&id=e65f6608", function () {
      api.rerender('e65f6608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/ad-settings/placement/r-ad-placement-dropdown-multiple.vue"
export default component.exports